
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { uiOpenModal } from '../../../../actions/ui'
// import renderHTML from 'react-render-html';
import parse from 'html-react-parser';
import { getFloat, getTradeLock } from '../../../../helpers/fetch'
import { cartAddNew } from '../../../../actions/auth';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

export const ProductCardStock = ({item}) => {
    
    const {name_color,
        nombre,
        imagen,
        sticker,
        inspect,
        categoria,
        tradable,
        tradeLock,
        precio,
        oferta,
        float,
        tieneFloat,
        etiqueta,
        viewInInventary}= item

    const { productsDB, auth } = useSelector( state => state)
    

  const {cart} = auth

  const [inCart, setInCart] = useState(false)

  useEffect(() => {

    if(cart){

        cart.map(itemInCart => {
            if(item.id === itemInCart.id){
                
                setInCart(true)
            }
        })
    }
  }, [cart])
  

  
    let carritoArr = []
    if(localStorage.getItem('cart')){
        carritoArr= JSON.parse( localStorage.getItem('cart') )
    }



    let itemSell 
        productsDB.map( prod => { 
        if(prod.viewInInventary === item.viewInInventary){
            return itemSell =true
        }

    })


    const dispatch = useDispatch()

    const [float2, setFloat2] = useState('')
    // const [priceSteam, setPriceSteam] = useState('')

    // getPriceSteamCheck(item.market_hash_name).then(res => setPriceSteam(res))

    //TODO float
    
    if(tieneFloat && !float){
        // console.log('float')
      
        getFloat(item).then( resp =>  setFloat2(resp))
    }

    let trade
    if(tradable === 0){
        // console.log(item.nombre)

       trade = getTradeLock(tradeLock)
    }
       

    const handleItemModal = (item) =>{

        // console.log(item)
        dispatch( uiOpenModal(item) )
    }

    const handleCart = () =>{
        if( JSON.parse( !localStorage.getItem('token') )){
            return Swal.fire({
                icon: 'info',
                title: 'Oops..',
                text: 'Tienes que haber iniciado session para agregar un item al carrito',
                footer: '<a href="/login">Iniciar Sessión</a>',
                showConfirmButton: false,
              })
        }

        if(localStorage.getItem('cart')){
            console.log('item guardado en storage')
            // let carritoArr = JSON.parse( localStorage.getItem('cart') )
            let newCart =[
                ...carritoArr,
                item
            ]
            localStorage.setItem('cart' , JSON.stringify(newCart))
        }else{
            localStorage.setItem('cart' , JSON.stringify([item]))

        }

        dispatch( cartAddNew(item) )
        
    }
    


  return (
    <>
     {
        !(tradable === 0 && tradeLock === null) && // filtra los productos no vendibles (medallas etc)
            // !itemSell&&  filtra los productos ya en venta
        <article 
            className='card-container   animate__animated animate__fadeIn mt-2 ' 
            onClick={()=>handleItemModal(item)}
            // onSelect={onSelect}
            
            >
            <div className={`${categoria} card_item `}>
                <div className={itemSell && 'aq' }></div>

                {trade&&
                
                    <div className='tradelock'>
                        <div className='esquinero'>

                        </div>
                        <p>{trade}</p>
            
                    </div>
                }

                { float&&
                <div className='float'>
                    <p>Float: {float}</p>
                </div>
                
                }
                { float2&&
                <div className='float'>
                    <p>Float: {float2}</p>
                </div>
                
                }
                

                { etiqueta&&
                <div className='etiqueta'>
                   
                    <i className="fa-solid fa-tag"></i>
                    <div className='etiqueta-info'>
                            {etiqueta}
                    </div>

                    
                </div>
                }

                <div className='steamView'>
                    
                   <a href={viewInInventary} target="_blank" ><i className="fa-brands fa-steam-square"></i></a> 
                    <div className='steamView-info'>
                           ver en el invetario Steam
                    </div>

                    
               </div>
                
               <img src={ imagen } alt="" />
                {sticker&&

                    <div className='sticker-container'> 
                        <div className='sticker-info'>
                        { parse(`${sticker.name}`) }
                        </div>

                        <div  className="sticker-icon">
                            <div className='sticker'>

                            { parse(`${sticker.icon}`) }
                            </div>
                        </div>
                    </div>
                
                }
   
                <hr />
                <div className='item-name' style={{color: `#${ name_color }` }}>
                  {nombre}
                </div>
                {/* MENU DE LOS ITEMS EN EL MAIN MENU */}
                <div className='item-show'>
                {/* (sticker !== null) && renderHTML(sticker)   */}
                <div id='sticker'>
               
                </div>
                    {(oferta >= 1)?

                        (precio !== '' && precio !== undefined)
                            &&

                            <div className='precio oferta'>
                                <span>AR$ {" "+ Math.round(precio - (precio*oferta/100)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} </span>
                                <span className='precio-anterior'>AR$ {precio}</span>
                                {/* {!inCart&& 
                                
                                <i className="fa-solid fa-cart-shopping cart" onClick={ handleCart }></i>

                                }
                                {inCart &&
                                // <i className='inCart' >en Carrito</i>
                                <Link to="/cart" className='inCart'>En carrito</Link>

                                } */}
                                <span className='off'> {oferta}%OFF</span>
                            </div>
                        :
                        (precio !== '' && precio !== undefined)
                            &&

                            <div className='precio'>
                                <span>AR$ {" "+ precio.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} </span>

                                {/* {!inCart&& 
                                
                                <i className="fa-solid fa-cart-shopping cart" onClick={ handleCart }></i>

                                }
                                {inCart &&
                                <Link to="/cart" className='inCart'>En carrito</Link>

                                } */}
                            </div>


                    }
                   
                    {
                        (precio !== '' && precio !== undefined && !inspect.includes('undefined'))&&
                        
                    <div className='inspect'>
                      
                        <a href={inspect}>Ver en el juego <i className="fa-brands fa-steam"></i></a>
                        
                    </div>

                    
                    }

                </div>
               
            </div>

            
         

        </article>
}
    </>

    
  )
}
